<script>
  export default{
    name: 'dash-proximos-leiloes',
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="panel hbox hbox-auto-xs no-border">
    <div class="col wrapper">
      <i class="fa fa-circle-o text-info m-r-sm pull-right"></i>
      <h4 class="font-thin m-t-none m-b-none text-primary-lt">Próximos Leilões</h4>
      <span class="m-b block text-sm text-muted">Leilões cadastrados que vão acontecer nos próximos 30 dias</span>
      <div style="height: 240px; padding: 10px; position: relative; overflow-y: auto; overflow-x: hidden">
        <div class="streamline b-l m-b">
          <div class="sl-item b-success b-l">
            <div class="m-l">
              <div class="text-muted">17:30</div>
              <p><span class="label bg-success">Online/Presencial</span> <a>1208 - Veículos de Financeiras e Seguradoras.</a></p>
            </div>
          </div>
          <div class="sl-item b-primary b-l">
            <div class="m-l">
              <div class="text-muted">Quinta, 25 de Março</div>
              <p><span class="label bg-primary">Presencial</span> <a>1208 - Veículos de Financeiras e Seguradoras.</a></p>
            </div>
          </div>
          <div class="sl-item b-info b-l">
            <div class="m-l">
              <div class="text-muted">Sábado, 27 de Março</div>
              <p><span class="label bg-info">Online</span> <a>1208 - Máquinas e Equipamentos.</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col wrapper-lg w-lg bg-light dk r-r">
      <div class="m-t-n m-b color-light">
        <a><i class="fa fa-chevron-left"></i></a>
        <a class="pull-right"><i class="fa fa-chevron-right"></i></a>
      </div>
      <span class="label label-sm bg-success">Hoje</span>
      <h4 class="font-thin m-t-none m-b">1208 Veículos de Financeiras e Seguradoras</h4>
      <div class="">
        <div class="">
          <span class="pull-right text-primary">60%</span>
          <span>Loteado</span>
        </div>
        <div class="progress progress-xs m-t-sm bg-white">
          <div class="progress-bar bg-primary" data-toggle="tooltip" data-original-title="60%" style="width: 60%"></div>
        </div>
        <div class="">
          <span class="pull-right text-info">35%</span>
          <span>Com lances automáticos</span>
        </div>
        <div class="progress progress-xs m-t-sm bg-white">
          <div class="progress-bar bg-info" data-toggle="tooltip" data-original-title="35%" style="width: 35%"></div>
        </div>
        <div class="">
          <span class="pull-right text-info">92%</span>
          <span>Possibilidade de arremate</span>
        </div>
        <div class="progress progress-xs m-t-sm bg-white">
          <div class="progress-bar bg-info" data-toggle="tooltip" data-original-title="92%" style="width: 92%"></div>
        </div>
      </div>
      <!--<p class="text-muted">Dales nisi nec adipiscing elit. Morbi id neque quam. Aliquam sollicitudin venenatis</p>-->
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// DashLeiloes.vue?1e0b24de